
import { mapGetters } from "vuex";

export default {
  data() {
    return {};
  },
  computed: {},
  methods: {},
  mounted() {
  },
  head() {
    return {
      title: 'Jun Mao | Senior Software Engineer | American Credit',
      meta : [
        {
          hid: 'description',
          name: 'description',
          content: 'Meet American Credit\'s Senior Software Engineer Jun Mao. One great team, one great goal of quickly getting you the secured business loan you need.'
        },
        {
          hid: 'keywords',
          name: 'keywords',
          content: 'secured business loan, Jun Mao, american credit'
        }
      ]
    }
  }
};
